import React from "react";
import PropTypes from "prop-types";
import { Table } from "../components";
import {
    stringComparator,
    dateComparator,
    numberComparator
} from "utilities/table";
import { OrderedMap } from "immutable";
import ReportsService from "services/reports-service";

class ReportingViewTemplate extends React.Component {
    state = {
        reportData: this.props.rows,
        isFilterApplied: false
    }
    onFilter = (values) => {
        let filteredData = values && this.props.rows.filter(_ => {
            return Object.keys(_).some(k => _[k].toLowerCase().includes(values.toLowerCase()));
        });
        this.setState({
            reportData: filteredData,
            isFilterApplied: true
        });
    }
    onApiXlsxDownload = () => {
        ReportsService.downloadReport(this.props.reportId, new OrderedMap(this.props.filters)
            .map(_ =>
                _._isAMomentObject
                    ? _.format("YYYY-MM-DD")
                    : (_ && typeof _ === "object" && _.length ? JSON.stringify(_) : _)
            )
            .toJS()).then(res => {
            var blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
            var elem = window.document.createElement("a");
            elem.href = window.URL.createObjectURL(blob);
            elem.download = `${this.props.reportName}.xlsx`;
            document.body.appendChild(elem);
            elem.click();
            document.body.removeChild(elem);
        });
    }

    componentDidUpdate() {
        if(
            (
                (this.props.rows && this.props.rows.size) !== (this.state.reportData && this.state.reportData.size)
            ) &&
            !this.state.isFilterApplied
        ) {
            this.setState({
                reportData: this.props.rows
            });
        }
    }


    render() {
        const { rows, columns, loading, reportName } = this.props;
        const columnsWithSorter = columns.map(_ => {
            let col = _;
            if(col.dataType === 1 || col.dataType === 2) {
                col.sorter = (a,b) => numberComparator(a.dataIndex, b.dataIndex);
            }

            if(col.dataType === 3) {
                col.sorter = (a,b) => stringComparator(a.dataIndex, b.dataIndex);
            }

            if(col.dataType === 4 || col.dataType === 5) {
                col.sorter = (a,b) => dateComparator(a.dataIndex, b.dataIndex);
            }

            if(col.dataType === 6) {
                col.sorter = (a,b) => numberComparator(a.dataIndex, b.dataIndex);
            }
            
            return col;
        });
        return (
            <Table
                className= {"padless-table inbox-table"}
                title={reportName}
                columns={columnsWithSorter}
                checkedColumns={columnsWithSorter.map(_ => _.dataIndex).toList().toArray()}
                keyFilter={"id"}
                data={this.state.reportData || rows}
                loading={loading}
                showXlsxBtn={false}
                showFilters={false}
                csvSuffix={reportName}
                // ignoreKeyFilter={false}
                size={"small"}
                pagination={false}
                tablePagination={false}
                showTopSection={true}
                spanConfig={{
                    title: 4,
                    filters: 10
                }}
                // onFilter={this.onFilter}
                showApiXlsxDownload={true}
                onApiXlsxDownload={this.onApiXlsxDownload}
            />
        );
    }
}

ReportingViewTemplate.propTypes = {
    rows: PropTypes.object,
    columns: PropTypes.object,
    loading: PropTypes.bool,
    reportName: PropTypes.string,
    reportId: PropTypes.number,
    filters: PropTypes.object
};

export default ReportingViewTemplate;
